jQuery(function($) {

  // Video hide and play
  $('.play-video').click(function(event) {
    var video = document.getElementById('video-to-play');

    event.preventDefault();
    $(this).addClass('hide');

    video.play();
  });

  // Testimonials Slider
  $('.testimonials-slider').slick({
	  infinite: true,
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  arrows: true,
	  responsive: [
	  	{
	  		breakpoint: 1023,
	      settings: {
	        slidesToShow: 2
	      }
	  	},
	  	{
	  		breakpoint: 768,
	      settings: {
	        slidesToShow: 1
	      }
	  	}
	  ]
	});

  // Testimonials Slider
  $('.testimonials-single-slider').slick({
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	});

	// Smooth Scroll
   $('.smooth-scroll').click(function () {
      $('html,body').animate({
      		scrollTop: 0
      	}, 1600, 'easeOutExpo'
      );
      return false;
   });

  $('.smooth-scroll-to-anchor').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 80
        }, 400);
        return false;
      }
    }
  });

  // Resource text search
  var debounce = null;
  $('.resource-search').on('keyup', function(e){
    clearTimeout(debounce);
    debounce = setTimeout(function(){
      var search_term = $('.resource-search').val();
      $('input[name=s]').val(search_term);
      $('input[name=paged]').val(1);
      $('input[name=type]').val('search');
      $('.resources-filter').trigger('submit');

      // Resource landing - add search parameter to See More link
      if ($('.resource-intro a').length) {
        $('.resource-intro a').each(function() {
          var href = $(this).attr('href');
          if (search_term !== "") {
            href = href.replace(/([?&])search_term=[^&]+/, '$1search_term=' + search_term);
            if (href.indexOf('search_term=') === -1) {
              href += (href.indexOf('?') === -1 ? '?' : '&') + 'search_term=' + search_term;
            }
          } else {
            href = href.replace(/[?&]search_term=[^&]+/, '');
          }
          $(this).attr('href', href);
        });
      }
    }, 700);
  });

  // Resource read more
  $('.resource-more-under').on('click', function() {
    $('input[name=type]').val('load_more');

    var filter = $(this).parent('.resources-filter');

    var total = parseInt(filter.find('input[name=total]').val());
    var paged = parseInt(filter.find('input[name=paged]').val()) + 1;
    var posts_per_page = parseInt(filter.find('input[name=posts_per_page]').val());

    filter.find('input[name=paged]').val(paged);
    filter.find('input[type=submit]').val('Loading...');

    if(paged * posts_per_page >= total) {
      filter.fadeOut();
    }

    $(this).parent().trigger('submit');
  });

  // Resource AJAX
  $('.resources-filter').on('submit', function(e) {
    e.preventDefault();

    var filter = $(this);
    var paged = parseInt(filter.find('input[name=paged]').val());
    var posts_per_page = parseInt(filter.find('input[name=posts_per_page]').val());

    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(),
      type: filter.attr('method'),
      beforeSend: function (xhr) {},
      success: function (data) {
        var result = JSON.parse(data);

        $('input[name=total]').val(result['total']);
        if(paged * posts_per_page >= result['total']) {
          filter.fadeOut();
        } else {
          filter.fadeIn();
        }

        if(filter.find('input[name=type]').val() == 'search') {
          filter.parent().find('.grid').html(result['content']);
        } else {
          filter.parent().find('.grid').append(result['content']);
        }
        filter.find('input[type=submit]').val('Load More');
      }
    });
    return false;
  });



  // Hero rotating titles
  setInterval(function(){
  var items = $('.rotating-hero-title');
  items.each(function(ind,val){
      if($(this).hasClass('active')){
            $(this).removeClass('active');
            if(ind !== items.length - 1) {
                items.eq(ind + 1).addClass('active');
                return false;
            }else{
                items.eq(0).addClass('active');
                return false;
            }
      }
  });
  },2300);

  //Pillar filters
  if($('.pillar__filter').length) {
    $('.pillar__filter_options span:first-of-type').addClass('active');
    $('.pillar__section:first-of-type').addClass('active');
    $('.pillar__articles_seemore').on('click', function() {
        $(this).closest('.pillar__articles_container').find('.post-card').toggleClass('active');
        if($(this).text() == 'See More') {
          $(this).text('See Less');
        } else {
          $(this).text('See More');
        }
    });
    $('.pillar__filter_options span').on('click', function() {
        var target = $(this).data('filter');
        $('.pillar__section').hide();
        $('.pillar__' + target).show();
        $('.pillar__filter_options span').removeClass('active');
        $(this).addClass('active');
    });
  }

  // Resource sidebar filters
  $('.toggle-type').on('click', function() {
    if($('.toggle-type:not(.disabled)').length > 1 || $(this).hasClass('disabled')) {
      var toggle = $(this).data('toggle');
      $('div[data-type="'+toggle+'"]').slideToggle();
      $(this).toggleClass('disabled');
    }
  });

  //Resources secondary nav
  $('.resources-nav a').on('mouseover', function() {
    var resourceLeft = $(this).offset().left;
    $('.resources-nav').addClass('active');
    $('.resources-nav-secondary').addClass('active').css('left', resourceLeft);
  });
  $('body').mouseover(function (evt) {
    if (evt.target.getAttribute("class") == 'resources-nav' || evt.target.getAttribute("class") == 'resources-nav-secondary')
      return;
    if ($(evt.target).closest('.resources-nav').length || $(evt.target).closest('.resources-nav-secondary').length)
      return;
    $('.resources-nav').removeClass('active');
    $('.resources-nav-secondary').removeClass('active');
  });

  // Metric Benchmark
  if($('.page-template-page-metrics-benchmark').length) {

    $(window).on('resize scroll', function(){

      // Scroll header effect
      if($(window).scrollTop() > 0){
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }

      // Pin sidebar
      var content_start = $('.metrics-main').offset().top;
      var current_scroll = $(window).scrollTop();
      var header_height = $('header').outerHeight();
      if(current_scroll > content_start - header_height - 32) {
        $('.metrics-sidebar').addClass('pinned');
      } else {
        $('.metrics-sidebar').removeClass('pinned');
      }

      // Light mode
      var light_mode_start = $('.light-mode').offset().top;
      if(current_scroll > light_mode_start - ($(window).height() / 2)) {
        $('html').addClass('light');
      } else {
        $('html').removeClass('light');
      }

      if(!$('body').hasClass('anchor')) {
        active_sidebar_link();
      }

    }).trigger('scroll');

    // Anchor scrolling
      $(".metrics-sidebar a").click(function(e) {
        e.preventDefault();
        var link = $(this).attr("href");
        $('body').addClass('anchor');
        $('html').animate({scrollTop: $(link).offset().top - 120}, 400);
        setTimeout(function() {
          $('body').removeClass('anchor');
          active_sidebar_link();
        }, 400);
    });


    // Active sidebar link
    function active_sidebar_link() {
      $($(".metrics-main .detect").get().reverse()).each(function() {
        var current_scroll = $(window).scrollTop();
        var current_section_start = $(this).offset().top;

        if(current_scroll > current_section_start - ($(window).height() / 2)) { // Starting from the bottom, check if top of current section is in center of viewport

          var current_section_name = $(this).attr('id');
          $('.metrics-sidebar a:not([data-section-label='+current_section_name+'])').removeClass('active'); // Remove active state from other sidebar links
          $('.metrics-sidebar a[data-section-label='+current_section_name+']').addClass('active'); // Add active state to this sidebar link
          $('.metrics-sidebar a[data-section-label='+current_section_name+']').closest('.sidebar-section').siblings().find('.sidebar-sub-sections').slideUp(); // Close other subnavs
          if($('.metrics-sidebar a[data-section-label='+current_section_name+']').hasClass('sidebar-sub-section-link')) { // Check for subnav and open it
            $('.metrics-sidebar a[data-section-label='+current_section_name+']').closest('.sidebar-sub-sections').slideDown();
          }

          return false; // Stop the each() loop if there is a match
        }
      });
    }
  }

  // Mobile nav toggle
  $('.mobile-toggle').on('click', function() {
    $('.mobile-nav').toggleClass('hidden');
  });

});